import mixitup from 'mixitup';

const mixitupContainer = document.querySelector('.gallery-page');

if (mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: 'all',
        },
        selectors: {
            target: '.gallery',
        },
        animation: {
            easing: 'ease-in-out',
        },
    });
}

// Click event on filter buttons and hides the filter selection box. (HINT: working for GallyPage and RoomOverviewPage Filter)
const buttons = document.querySelectorAll('.filter-select-box.-js-accordion__target .filter-select__button');
const filterSection = document.querySelector('.filter-section.-js-accordion');

if (buttons) {
    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            filterSection.classList.remove('-js-accordion--open');
            const filterSelectBox = document.querySelector('.filter-select-box.-js-accordion__target');
            filterSelectBox.style.maxHeight = '0';
        });
    });
}
